import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const MarketStatusBadge = () => {
  const [marketStatus, setMarketStatus] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    fetchMarketStatus();
    
    // Refresh every minute
    const interval = setInterval(fetchMarketStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  const fetchMarketStatus = async () => {
    try {
      const response = await axios.get(`${API_BASE}/api/market/status`);
      setMarketStatus(response.data);
    } catch (err) {
      console.error('Failed to fetch market status:', err);
    }
  };

  if (!marketStatus) return null;

  const isOpen = marketStatus.isOpen;

  return (
    <div 
      className="relative inline-flex"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div 
        className="flex items-center gap-1.5 cursor-help"
        data-testid="market-status-badge"
      >
        <span 
          className={`w-2 h-2 rounded-full ${isOpen ? 'animate-pulse' : ''}`}
          style={{ backgroundColor: isOpen ? '#4ade80' : '#fbbf24' }}
        />
        <span 
          className="text-sm font-medium"
          style={{ color: isOpen ? '#4ade80' : '#fbbf24' }}
        >
          {isOpen ? 'Market Open' : 'Market Closed'}
        </span>
      </div>

      {/* Tooltip */}
      {showTooltip && !isOpen && marketStatus.message && (
        <div 
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 rounded-lg whitespace-nowrap z-50"
          style={{ 
            background: '#27272a',
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
          }}
        >
          <p className="text-xs" style={{ color: '#e4e4e7' }}>
            {marketStatus.message}
          </p>
          {/* Arrow */}
          <div 
            className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0"
            style={{
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: '6px solid #27272a'
            }}
          />
        </div>
      )}
    </div>
  );
};

export default MarketStatusBadge;
